import React, { useState } from "react";
import PublicLayout from "@/components/PublicLayout";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function Contacto() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", company: "", message: "" });
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/leads/public", { ...form, source: "landing_contact" });
      toast.success("Recibimos tu solicitud. Te contactaremos pronto.");
      setForm({ name: "", email: "", phone: "", company: "", message: "" });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <PublicLayout>
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <p className="text-xs uppercase tracking-widest text-[#F26A21] font-semibold">Contacto</p>
        <h1 className="mt-2 text-4xl sm:text-5xl font-bold text-[#0B0B0B] font-display leading-tight">
          Hablemos.
        </h1>
        <p className="mt-4 text-lg text-[#0B0B0B]">
          Cuéntanos qué necesitas para tu institución o equipo — respondemos en menos de 48h.
        </p>

        <form onSubmit={submit} data-testid="contact-form" className="mt-10 p-6 bg-[#F9FAFB] border border-gray-200 rounded-xl space-y-4">
          {[
            { k: "name", label: "Nombre completo", req: true },
            { k: "email", label: "Correo", req: true, type: "email" },
            { k: "phone", label: "Teléfono" },
            { k: "company", label: "Institución / Empresa" },
          ].map((f) => (
            <div key={f.k}>
              <label className="text-[11px] font-semibold uppercase tracking-widest text-gray-600">{f.label}{f.req && <span className="text-red-400 ml-1">*</span>}</label>
              <input
                data-testid={`contact-${f.k}`}
                required={f.req}
                type={f.type || "text"}
                value={form[f.k]}
                onChange={(e) => setForm({ ...form, [f.k]: e.target.value })}
                className="w-full mt-1 bg-white border border-gray-200 rounded-md px-3 py-2 text-sm text-[#0B0B0B] focus:outline-none focus:border-[#F26A21]"
              />
            </div>
          ))}
          <div>
            <label className="text-[11px] font-semibold uppercase tracking-widest text-gray-600">Mensaje</label>
            <textarea
              data-testid="contact-message"
              rows={4}
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              className="w-full mt-1 bg-white border border-gray-200 rounded-md px-3 py-2 text-sm text-[#0B0B0B] focus:outline-none focus:border-[#F26A21]"
            />
          </div>
          <button type="submit" disabled={submitting} data-testid="contact-submit-btn" className="w-full py-3 rounded-md bg-[#F26A21] hover:bg-[#D9541A] text-[#0B0B0B] font-semibold disabled:opacity-60">
            {submitting ? "Enviando..." : "Enviar mensaje"}
          </button>
        </form>
      </section>
    </PublicLayout>
  );
}
